// extracted by mini-css-extract-plugin
export default {"voice_chat_list_tab":"ListTab_voice_chat_list_tab__8oQo8","active":"ListTab_active__UPt8T"};